import Api from './api'

export const apiInstance = new Api()
